export interface AccountGrantAssignmentsFormFields {
  accountGrantId?: string;
  organizationId: string;
  accountGrantOrganizationAssignmentsId?: string;
}

const edit = ({
  accountGrantId,
  organizationId,
  id,
}: {
  accountGrantId: number;
  organizationId: number;
  id: string;
}): AccountGrantAssignmentsFormFields => {
  return {
    accountGrantId: accountGrantId.toString(),
    organizationId: organizationId.toString(),
    accountGrantOrganizationAssignmentsId: id.toString(),
  };
};

const _new = ({organizationId}: {organizationId: string}) => {
  return {
    organizationId: organizationId.toString(),
  };
};

const toMutation = (form: AccountGrantAssignmentsFormFields) => {
  return {
    accountGrantId: form.accountGrantId,
    organizationId: form.organizationId,
    accountGrantOrganizationAssignmentsId: form.accountGrantOrganizationAssignmentsId,
  };
};

const AccountGrantAssignmentsForm = {
  edit,
  toMutation,
  new: _new,
};

export default AccountGrantAssignmentsForm;
